import { render, staticRenderFns } from "./SampleDextUploader.vue?vue&type=template&id=53478d66"
import script from "./SampleDextUploader.vue?vue&type=script&lang=js"
export * from "./SampleDextUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53478d66')) {
      api.createRecord('53478d66', component.options)
    } else {
      api.reload('53478d66', component.options)
    }
    module.hot.accept("./SampleDextUploader.vue?vue&type=template&id=53478d66", function () {
      api.rerender('53478d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleDextUploader.vue"
export default component.exports